
import {Component, Vue} from 'vue-property-decorator';

@Component
export default class SiteFooter extends Vue {
  currentYear = 2018;

  private mounted() {
    this.currentYear = new Date().getFullYear();
  }
}
